/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { css, StyleSheet } from 'aphrodite';
import React from 'react';
import { SizeMe } from 'react-sizeme';
import { PdfViewer } from '../../common/PdfViewer/PdfViewer';
import { ESignProviders } from '@shared/constants/document';

export namespace DocumentViewer {
  export interface Props {
    activePdfUrl?: string;
    activeEditUrl?: string;
    eSignProvider?: string;
  }
}

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    height: '100%',
  },
  docuSignIframe: {
    width: '100%',
    // -30px fixes iframe overflow, and hides the DocuSign footer
    height: `calc(100% - 30px)`,
    border: 'none',
  },
  oneSpanIframe: {
    width: '100%',
    height: `100%`,
    border: 'none',
  },
});

export const DocumentViewer: React.FC<DocumentViewer.Props> = ({ activePdfUrl, activeEditUrl, eSignProvider }) => {
  return (
    <SizeMe refreshMode={'debounce'}>
      {({ size }) => (
        <div className={css(styles.wrapper)} data-it="DocumentViewer">
          {activeEditUrl ? (
            <iframe
              data-it="iframe-edit-doc"
              className={css(eSignProvider === ESignProviders.ONESPAN ? styles.oneSpanIframe : styles.docuSignIframe)}
              src={activeEditUrl}
            />
          ) : activePdfUrl ? (
            <>
              <PdfViewer width={Number(size.width)} fileUrl={activePdfUrl} />
            </>
          ) : (
            <div />
          )}
        </div>
      )}
    </SizeMe>
  );
};
